export default __webpack_public_path__ + "static/media/backIcon.406df0a2.svg";